
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "class": "icon",
    "width": "200px",
    "height": "200.00px",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M821.333 138.667c64.8 0 117.334 52.533 117.334 117.333v149.333a32 32 0 0 1-32 32 74.667 74.667 0 0 0 0 149.334 32 32 0 0 1 32 32V768c0 64.8-52.534 117.333-117.334 117.333H202.667c-64.8 0-117.334-52.533-117.334-117.333V618.667a32 32 0 0 1 32-32 74.667 74.667 0 0 0 0-149.334 32 32 0 0 1-32-32V256c0-64.8 52.534-117.333 117.334-117.333h618.666z m0 64H202.667A53.333 53.333 0 0 0 149.333 256v121.045C210.485 391.488 256 446.432 256 512c0 65.568-45.515 120.512-106.667 134.955V768a53.333 53.333 0 0 0 53.334 53.333h618.666A53.333 53.333 0 0 0 874.667 768V646.955C813.515 632.512 768 577.568 768 512c0-65.568 45.515-120.512 106.667-134.955V256a53.333 53.333 0 0 0-53.334-53.333z m-436.48 124.746a32 32 0 0 1 45.067 4.096L512 430.016l82.08-98.507a32 32 0 1 1 49.173 40.982l-71.84 86.176h47.254a32 32 0 0 1 31.946 30.122l0.054 1.878a32 32 0 0 1-32 32h-69.334v42.666h69.334a32 32 0 0 1 31.946 30.123l0.054 1.877a32 32 0 0 1-32 32h-69.334V672a32 32 0 0 1-30.122 31.947l-1.878 0.053a32 32 0 0 1-32-32v-42.667h-80a32 32 0 0 1-31.946-30.122l-0.054-1.878a32 32 0 0 1 32-32h80v-42.666h-80a32 32 0 0 1-31.946-30.123l-0.054-1.877a32 32 0 0 1 32-32h47.232l-71.818-86.187a32 32 0 0 1 2.581-43.723z",
        "fill": "#ffffff"
      }
    }
  ]
})
    }
  